import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import utilServices from 'app/services/util-services'
import { updateIndicator } from 'app/redux/store/features/configs'
import { getEnrolmentById, selectItemById, updateEnrolment } from 'app/redux/store/features/enrolments'
import UpdateEnrolmentForm from './UpdateEnrolmentForm'

const UpdateEnrolment = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const [apiCallInProgress, setApiCallInProgress] = useState(false)

    const { state } = useLocation()
    const { enrolmentId } = state
    const { enrolments, loading, error } = useSelector((state) => state.enrolments)
    const enrolment = selectItemById(enrolments, enrolmentId)

    useEffect(() => {
        if (utilServices.isNullOrUndefined(enrolment.id)) dispatch(getEnrolmentById({ id: enrolmentId }))
    }, [])

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)

        if (error) handleError(error)
        else {
            enqueueSnackbar('Enrolment updated successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            dispatch(updateIndicator({ inProgress: false }))
            navigate('/registrations/enrolments')
        }
    }, [loading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const onUpdateEnrolmentGrid = async () => {
        setApiCallInProgress(true)
        dispatch(updateIndicator({ inProgress: true }))
        dispatch(updateEnrolment({ ...enrolment }))
    }

    return (
        <React.Fragment>
            <UpdateEnrolmentForm
                enrolmentData={enrolment}
                updateEnrolment={onUpdateEnrolmentGrid}
                handleError={handleError}
            />
        </React.Fragment>
    )
}

export default UpdateEnrolment
